module.exports = __webpack_public_path__ + "static/img/circle-2.3d0e281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle-2.png
// module id = vNPd
// module chunks = 0